import { ManaulPage } from "./../manaul/manaul";
import { SelectLanguagePage } from "./../select-language/select-language";
import { ShopperRequrementPage } from "./../shopper-requrement/shopper-requrement";
import { PlazaResultPage } from "./../plaza-result/plaza-result";
import { TranslateService } from "@ngx-translate/core";
// import { PlazaSelectThemePage } from "./../plaza-select-theme/plaza-select-theme";
import { PlazaSelectPlanPage } from "./../plaza-select-plan/plaza-select-plan";
import { RequestOptions, Headers, Http } from "@angular/http";
import { PlazaMissionPage } from "./../plaza-mission/plaza-mission";
import { PlazaOverviewPage } from "./../plaza-overview/plaza-overview";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import { NavController, LoadingController } from "ionic-angular";
import { ServiceProvider } from "../../providers/service/service";
import { PlazaSlotThemePage } from "../plaza-slot-theme/plaza-slot-theme";
import { DiscountListPage } from "../discount-list/discount-list";
import { LoginPage } from "../login/login";

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  plaza_name = "Plaza A";
  plaza = "A";
  step: any;
  theme_no = 0;
  round = 0;
  title = "HOME PAGE";
  themes = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.storage.get("info").then((info) => {
      this.plaza_name = info.team.plaza_name;
      if (this.plaza_name == "Plaza A") {
        this.plaza = "A";
      } else if (this.plaza_name == "Plaza B") {
        this.plaza = "B";
      } else if (this.plaza_name == "Plaza C") {
        this.plaza = "C";
      } else if (this.plaza_name == "Plaza D") {
        this.plaza = "D";
      } else if (this.plaza_name == "Plaza E") {
        this.plaza = "E";
      } else if (this.plaza_name == "Plaza F") {
        this.plaza = "F";
      }
    });
  }

  async ionViewDidLoad() {
    this.themes = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    // setInterval(() => {
    this.storage.get("token").then((token) => {
      var link = this.services.URLCheckStep;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.step = data.step;
            this.round = data.round;

            this.storage.get("themeSelect" + data.round).then((theme_no) => {
              this.theme_no = theme_no;
            });

            if (this.round > 1) {
              this.title = "Round " + this.round;
            }

            this.storage.get("currentStep").then((oldStep) => {
              if (!oldStep) {
                this.storage.set("currentStep", data.step);
              } else if (oldStep != data.step) {
                this.storage.set("currentStep", data.step);
                if (data.step == 1 && data.round == 1) {
                  this.storage.remove("stepGame");
                  this.storage.remove("roundGame");
                  this.storage.remove("language");
                  this.storage.remove("quizRound");
                  this.navCtrl.setRoot(SelectLanguagePage);
                }
              }
            });

            this.storage.get("roundGame").then((oldRound) => {
              if (!oldRound) {
                this.storage.set("roundGame", data.round);
              } else if (oldRound != data.round) {
                this.storage.set("roundGame", data.round);
              }
            });

            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            if (
              response.status == 403 &&
              response.message == "You are not allowed to perform this action."
            ) {
              if (this.storage.clear()) {
                this.navCtrl.setRoot(LoginPage);
              }
            }

            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });

    // }, 3000);
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLCheckStep;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.step = data.step;
            this.round = data.round;

            this.storage.get("themeSelect" + data.round).then((theme_no) => {
              this.theme_no = theme_no;
            });

            if (this.round > 1) {
              this.title = "Round " + this.round;
            }

            this.storage.get("currentStep").then((oldStep) => {
              if (!oldStep) {
                this.storage.set("currentStep", data.step);
              } else if (oldStep != data.step) {
                this.storage.set("currentStep", data.step);
                if (data.step == 1 && data.round == 1) {
                  this.storage.remove("stepGame");
                  this.storage.remove("roundGame");
                  this.storage.remove("language");
                  this.storage.remove("quizRound");
                  this.navCtrl.setRoot(SelectLanguagePage);
                }
              }
            });

            this.storage.get("roundGame").then((oldRound) => {
              if (!oldRound) {
                this.storage.set("roundGame", data.round);
              } else if (oldRound != data.round) {
                this.storage.set("roundGame", data.round);
              }
            });

            refresher.complete();
          },
          (error) => {
            var response = JSON.parse(error._body);
            refresher.complete();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  overviewPage() {
    this.navCtrl.push(PlazaOverviewPage);
  }

  missionPage() {
    this.navCtrl.push(PlazaMissionPage);
  }

  shopperReqPage() {
    this.navCtrl.push(ShopperRequrementPage, {});
  }

  yourPlan() {
    this.navCtrl.push(PlazaSelectPlanPage);
  }

  theme() {
    this.navCtrl.push(PlazaSlotThemePage);
  }

  result() {
    this.navCtrl.push(PlazaResultPage);
  }

  manual() {
    this.navCtrl.push(ManaulPage);
  }

  gotoDiscount() {
    this.navCtrl.push(DiscountListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts